if (!customElements.get('leslis-footer-menu')) {
  customElements.define('leslis-footer-menu', class extends HTMLElement {
    connectedCallback() {
      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      if (!this.details || !this.summary) return;
      this.desktop = window.matchMedia('(min-width: 750px)');
      this.sync = () => {
        this.details.open = this.desktop.matches;
        this.summary.tabIndex = this.desktop.matches ? -1 : 0;
      };
      this.keepDesktopOpen = (event) => {
        if (this.desktop.matches) event.preventDefault();
      };
      this.desktop.addEventListener('change', this.sync);
      this.summary.addEventListener('click', this.keepDesktopOpen);
      this.sync();
    }
    disconnectedCallback() {
      this.desktop?.removeEventListener('change', this.sync);
      this.summary?.removeEventListener('click', this.keepDesktopOpen);
    }
  });
}
